import { HoverCard as MantineHoverCard, HoverCardProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedHoverCardProps extends HoverCardProps {
  gradientBorder?: boolean;
  gradientVariant?: GradientVariant;
}

interface HoverCardComponent extends React.ForwardRefExoticComponent<ThemedHoverCardProps & React.RefAttributes<HTMLDivElement>> {
  Target: typeof MantineHoverCard.Target;
  Dropdown: typeof MantineHoverCard.Dropdown;
}

const BaseHoverCard = MantineHoverCard as any;

const HoverCard = forwardRef<HTMLDivElement, ThemedHoverCardProps>(
  ({ gradientBorder = false, gradientVariant = 'primary', styles, children, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];

    if (!gradientBorder) {
      return (
        <BaseHoverCard ref={ref} styles={styles} {...rest}>
          {children}
        </BaseHoverCard>
      );
    }

    return (
      <BaseHoverCard
        ref={ref}
        styles={{
          ...styles,
          dropdown: {
            border: `2px solid ${gradient.from}`,
            ...(styles as any)?.dropdown,
          },
        }}
        {...rest}
      >
        {children}
      </BaseHoverCard>
    );
  }
) as HoverCardComponent;

HoverCard.displayName = 'HoverCard';

// Attach subcomponents
HoverCard.Target = MantineHoverCard.Target;
HoverCard.Dropdown = MantineHoverCard.Dropdown;

export default HoverCard;
